import toast from 'react-hot-toast'
import {
  useAccount,
  useConnect,
  useDisconnect,
  useSignMessage,
} from 'wagmi'

import {
  ChallengeType,
  useChallengeMutation,
  useUpdateMineWalletMutation,
} from '@/redux/user'

export const useSwitchAddress = () => {
  const { connector } = useAccount()
  const { connectAsync } = useConnect()
  const { disconnectAsync } = useDisconnect()
  const [challenge] = useChallengeMutation()
  const [updateMineWallet] = useUpdateMineWalletMutation()
  const { signMessageAsync } = useSignMessage()

  return (oldAddress: string | undefined) => async () => {
    try {
      if (!connector) return
      await disconnectAsync()
      const { accounts } = await connectAsync({ connector })
      const newAddress = accounts?.[0]
      if (newAddress.toUpperCase() === oldAddress?.toUpperCase()) {
        toast.success('Address not changed')
        return
      }
      const { data: challengeData } = await challenge({ address: newAddress, type: ChallengeType.Login })
      if (!challengeData) return
      const signedMessage = await signMessageAsync({ message: challengeData.message })
      const { id, name, icon } = connector
      const { error } = await updateMineWallet({
        address: newAddress,
        signedMessage,
        walletId: id,
        walletName: name,
        walletLogo: icon,
      })
      if (error) {
        return
      }
      toast.success('Wallet switched')
    } catch (e) {
      console.log(e)
    }
  }
}
